/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { featureCollection } from '@turf/helpers';
import { FeatureCollection, MultiPolygon, Polygon } from 'geojson';
import { Action, ActionCreators } from './actions';

export interface GroundStationCoverageFeatureProperties {
  siteDesignation?: string;
}

export interface GroundStationsState {
  // Coverage data is kept in this slice.
  coverage: FeatureCollection<Polygon | MultiPolygon>;
  requestGroundStationCoverageError?: string;
}

const emptyCoverage = featureCollection([]) as FeatureCollection<Polygon | MultiPolygon>;

export const initialGroundStationState: GroundStationsState = {
  coverage: emptyCoverage,
  requestGroundStationCoverageError: undefined,
};

export default function groundStationsReducer(
  state: GroundStationsState = initialGroundStationState,
  action: Action
): GroundStationsState {
  let partialState: Partial<GroundStationsState> | undefined;

  switch (action.type) {
    case ActionCreators.RequestGroundStationCoverage.type:
      partialState = {
        coverage: emptyCoverage,
        requestGroundStationCoverageError: undefined,
      };
      break;

    case ActionCreators.ReceivedGroundStationCoverageSuccess.type: {
      const response = action.payload.response as FeatureCollection<Polygon | MultiPolygon>;
      const coverage = response ?? emptyCoverage;

      partialState = {
        coverage,
        requestGroundStationCoverageError: undefined,
      };
      break;
    }

    case ActionCreators.ReceivedGroundStationCoverageError.type:
      partialState = {
        requestGroundStationCoverageError: action.payload.message,
      };
      break;

    default:
      return state;
  }

  return { ...state, ...partialState };
}